export const useTitle = (title: string): void => {
  document.title = title;
};
